import { Tabs, TabsProps } from "antd";
import { FormattedMessage, useIntl } from "react-intl";
import QuickActionButton from "../../components/common/QuickActionButton";
import SalonLocationsSelect from "../../components/common/SalonLocationsSelect";
import AccountingReports from "../../components/reports/tabs/AccountingReports";
import CustomerReports from "../../components/reports/tabs/CustomerReports";
import ReservationsReports from "../../components/reports/tabs/ReservationsReports";
import SalesReports from "../../components/reports/tabs/SalesReports";

type Props = {};

const Reports = (props: Props) => {
  const intl = useIntl();

  const items: TabsProps["items"] = [
    {
      key: "1",
      label: intl.formatMessage({
        id: "salesReportsLabel",
        defaultMessage: "تقارير المبيعات",
      }),
      children: <SalesReports />,
    },
    {
      key: "2",
      label: intl.formatMessage({
        id: "accountingReportsLabel",
        defaultMessage: "تقارير المحاسبة",
      }),
      children: <AccountingReports />,
    },
    {
      key: "3",
      label: intl.formatMessage({
        id: "reservationsReportsLabel",
        defaultMessage: "تقارير الحجوزات",
      }),
      children: <ReservationsReports />,
    },
    // {
    //   key: "4",
    //   label: intl.formatMessage({
    //     id: "staffReportsLabel",
    //     defaultMessage: "تقارير فريق العمل",
    //   }),
    //   children: <StaffReports />,
    // },
    {
      key: "5",
      label: intl.formatMessage({
        id: "customerReportsLabel",
        defaultMessage: "تقارير العملاء",
      }),
      children: <CustomerReports />,
    },
    // {
    //   key: "6",
    //   label: intl.formatMessage({
    //     id: "inventoryReportsLabel",
    //     defaultMessage: "تقارير الجرد",
    //   }),
    //   children: <InventoryReports />,
    // },
  ];
  const onChange = (key: string) => {
    console.log(key);
  };
  return (
    <div>
      <div className="flex justify-between w-full mb-4">
        <div className="w-full">
          <div className="flex items-center gap-2 text-2xl font-semibold leading-7 text-color-primary max-lg:text-xl text-end">
            <FormattedMessage
              id="salonReportsTitle"
              defaultMessage="تقارير المشروع الخاص بك"
            />
          </div>
          <div className="my-4 text-base font-normal leading-7 text-color-gray">
            <FormattedMessage
              id="salonReportsDescription"
              defaultMessage="هنا ستجد كلما ما يتعلق بتقارير مشروعك من مبيعات، محاسبات، جرد.."
            />
          </div>
        </div>
        <QuickActionButton />
      </div>
      <SalonLocationsSelect />
      <div className="mt-6 reports">
        <Tabs
          defaultActiveKey="1"
          items={items}
          onChange={onChange}
          tabBarStyle={{ margin: 0 }}
        />
      </div>
    </div>
  );
};

export default Reports;
